export default class Article extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-article', Article);
